<nz-spin [nzSpinning]="loading">
  <nz-tabset>
    <nz-tab nzTitle="Company Information">
      <section class=" space-y-[15px]">
        <div class="flex justify-end" *ngIf="this.isDataExistLocal('cs')">
          <button
            class="ml-2"
            nz-button
            (click)="this.patchCompanyInformationFromLocal('cs')"
            nzType="default"
            nz-dropdown>
            <div class='flex flex-row justify-center items-center gap-3'>
              <span> <lucide-icon class="localStorage-icons hover:cursor-pointer" name="database-backup"></lucide-icon></span>
              <span>Restore</span>
            </div>
          </button>
        </div>
        <div class="grid grid-cols-12 gap-5">
          <div class="md:col-span-3 col-span-12">
            <div class="my-4">
              <div class="grid grid-cols-1 gap-5" *ngIf="uploadAndPreview">
                <div class="bg-base-200 h-40 p-4">
                  <img
                    class="w-full h-full object-contain"
                    [src]="
              customerForm.get('logo').value
                ? customerForm.get('logo').value
                : placeholderPath
            "
                    alt=""/>
                </div>
                <div class="flex justify-center items-center">
                  <button nz-button nzType="default" (click)="uploadAndPreview = false">
                    Change Logo
                  </button>
                </div>
              </div>
              <div *ngIf="!uploadAndPreview">
                <ngx-dropzone [multiple]="false" (change)="onSelect($event)">
                  <ngx-dropzone-label>Company Logo</ngx-dropzone-label>
                  <ngx-dropzone-preview
                    *ngFor="let f of files"
                    [removable]="true"
                    (removed)="onRemove(f)">
                    <ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
                  </ngx-dropzone-preview>
                </ngx-dropzone>
                <nz-alert class="mt-2" nzType="info" nzShowIcon
                          nzMessage="Recommended: Upload an image no larger than 500kb."></nz-alert>
              </div>
            </div>
          </div>
          <div class="md:col-span-9 col-span-12">
            <form nz-form nzLayout="vertical" [formGroup]="customerForm">
              <nz-form-item class="flex">
                <nz-form-label
                  nzFor="companyName"
                >Company Name
                </nz-form-label>
                <nz-form-control [nzErrorTip]="nameCheck">
                  <input
                    type="text"
                    nz-input
                    formControlName="companyName"
                    placeholder="Enter company name"/>
                </nz-form-control>
                <ng-template #nameCheck>
                </ng-template>
              </nz-form-item>
              <nz-form-item class="flex">
                <nz-form-label nzFor="summary"
                >Company Description
                </nz-form-label
                >
                <nz-form-control>
                <textarea
                  class="w-full"
                  formControlName="summary"
                  placeholder="Enter Summary"
                  rows="5"
                  nz-input></textarea>
                </nz-form-control>
              </nz-form-item>

              <nz-form-item class="flex">
                <nz-form-label nzFor="websiteLink"
                >Website Link
                </nz-form-label>
                <nz-form-control [nzErrorTip]="websiteLinkCheck">
                  <input
                    type="text"
                    nz-input
                    formControlName="websiteLink"
                    placeholder="Enter Website Link"/>
                </nz-form-control>
                <ng-template #websiteLinkCheck>
                  <span *ngIf="formErrors.websiteLink.pattern">Please use the valid Url </span>
                </ng-template>
              </nz-form-item>
            </form>
          </div>
        </div>
      </section>
    </nz-tab>
    <nz-tab nzTitle="Costing">
      <section class="space-y-[15px]">
        <div class="flex justify-end" *ngIf="this.isDataExistLocal('cs')">
          <button
            class="ml-2"
            nz-button
            (click)="this.patchCostingFromLocal('cs')"
            nzType="default"
            nz-dropdown>
            <div class='flex flex-row justify-center items-center gap-3'>
              <span> <lucide-icon class="localStorage-icons hover:cursor-pointer" name="database-backup"></lucide-icon></span>
              <span>Restore</span>
            </div>
          </button>
        </div>
        <div class="grid grid-cols-12 gap-5">
          <div class="col-span-12">
            <div>
              <div class="mb-2 max-w-80">
                <form nz-form nzLayout="vertical" [formGroup]="costingForm">
                  <nz-form-item class="mb-3">
                    <nz-form-label  nzFor="costingCurrency">Display Cost on Itinerary</nz-form-label>
                    <nz-select formControlName="viewType">
                      <nz-option
                        *ngFor="let lang of this.costingType"
                        [nzValue]="lang?.value"
                        [nzLabel]="lang?.label"></nz-option>
                    </nz-select>
                  </nz-form-item>
                </form>
              </div>
              <div>
                <form nz-form nzLayout="vertical" [formGroup]="costingForm">
                  <div class="flex md:flex-row  flex-col justify-around gap-2" *ngIf="this.costingForm.get('viewType').value === 'custom'">
                    <nz-form-item class="mb-2">
                      <nz-form-label class="text-start" nzFor="costPerAdult"
                      >Cost Per Adult
                      </nz-form-label>
                      <nz-form-control>
                        <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                          <nz-input-number

                            class="w-full border-none"
                            [nzMin]="0"
                            nzPlaceHolder="Amount"
                            formControlName="costPerAdult"></nz-input-number>
                        </nz-input-group>
                        <ng-template #prefixCurrency>{{
                            this.singleItinerary?.tour?.currency | uppercase
                          }}
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="mb-2">
                      <nz-form-label class="text-start" nzFor="costPerChild"
                      >Cost Per Child
                      </nz-form-label>
                      <nz-form-control>
                        <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                          <nz-input-number
                            class="w-full border-none"
                            [nzMin]="0"
                            nzPlaceHolder="Amount"
                            formControlName="costPerChild"></nz-input-number>
                        </nz-input-group>
                        <ng-template #prefixCurrency>{{
                            this.singleItinerary?.tour?.currency | uppercase
                          }}
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                    <nz-form-item class="mb-2">
                      <nz-form-label class="text-start" nzFor="costPerInfant"
                      >Cost Per Infant
                      </nz-form-label>
                      <nz-form-control>
                        <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                          <nz-input-number
                            class="w-full border-none"
                            [nzMin]="0"
                            nzPlaceHolder="Amount"
                            formControlName="costPerInfant"></nz-input-number>
                        </nz-input-group>
                        <ng-template #prefixCurrency>{{
                            this.singleItinerary?.tour?.currency | uppercase
                          }}
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div class="max-w-80" *ngIf="this.costingForm.get('viewType').value === 'person'">
                    <nz-form-item>
                      <nz-form-label class="text-start" nzFor="costPerAdult"
                      >Per Person Cost
                      </nz-form-label>
                      <nz-form-control>
                        <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                          <nz-input-number
                            class="w-full border-none"
                            [nzMin]="0"
                            nzPlaceHolder="Amount"
                            formControlName="personCost"></nz-input-number>
                        </nz-input-group>
                        <ng-template #prefixCurrency>{{
                            this.singleItinerary?.tour?.currency | uppercase
                          }}
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                  <div class="max-w-80" *ngIf="this.costingForm.get('viewType').value === 'total'">
                    <nz-form-item>
                      <nz-form-label class="text-start" nzFor="costPerAdult"
                      >Total Tour Cost
                      </nz-form-label>
                      <nz-form-control>
                        <nz-input-group [nzPrefix]="prefixCurrency" class="py-0 pr-0 prefix-custom">
                          <nz-input-number
                            class="w-full border-none"
                            [nzMin]="0"
                            nzPlaceHolder="Amount"
                            formControlName="grandTotal"></nz-input-number>
                        </nz-input-group>
                        <ng-template #prefixCurrency>{{
                            this.singleItinerary?.tour?.currency | uppercase
                          }}
                        </ng-template>
                      </nz-form-control>
                    </nz-form-item>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </nz-tab>
  </nz-tabset>
</nz-spin>
<div *nzModalFooter>
  <button nz-button nzType="default" (click)="handleCancel()">Close</button>
  <button  nz-button nzType="primary"
          (click)="updateB2B()"
  >update
  </button>
</div>
